export default "__VITE_ASSET__BXMNAQkx__"